import { Reikwijdte } from "@/entities/dossier-details";
import { DossierSettings, useDetermineDossierSettings } from "@/entities/dossier-settings";
import { UseFormReturn, useWatch } from "react-hook-form";
import { UpdateDossierDetailsData } from "../utils";

export function usePresetComparison(
    dossierId: string,
    form: UseFormReturn<UpdateDossierDetailsData>,
    initialOmschrijving: string,
    initialReikwijdte: Reikwijdte
): { sectionsDiffer: boolean; nextSections: DossierSettings | null } {
    const selectedOmschrijving = useWatch({ control: form.control, name: "omschrijving" });
    const selectedReikwijdte = useWatch({ control: form.control, name: "reikwijdte" });

    const {
        data: previous,
        isPending: previousPending,
        error: previousError,
    } = useDetermineDossierSettings({
        dossierId,
        omschrijving: initialOmschrijving,
        reikwijdte: initialReikwijdte,
    });
    const {
        data: next,
        isPending: nextPending,
        error: nextError,
    } = useDetermineDossierSettings({
        dossierId,
        omschrijving: selectedOmschrijving,
        reikwijdte: selectedReikwijdte,
    });

    const pending = previousPending || nextPending;
    const error = previousError || nextError;
    const noData = !previous || !next;

    if (pending || error || noData) return { sectionsDiffer: false, nextSections: null };

    return { sectionsDiffer: DossierSettings.areSectionsDifferent(previous, next), nextSections: next };
}
